export default {
  catalogues: 'Katalog',
  catalogues_near_you: 'Katalog dan toko',
  closed: 'Tutup',
  expires: 'Valid',
  more_info: 'Informasi lebih lanjut',
  of: 'Dari',
  open: 'Buka',
  page: 'Halaman',
  stores: 'Toko',
  invalid_offers_disclaimer: 'Ponudbe v tem letaku ne veljajo v trgovinah v vaši bližini, odprite drug letak ali jih poiščite na drugem območju.',
}
